mapStoreKeyToPositionContextType